// import React, { useState, useRef, useEffect } from "react";
// import httpRequest from "../../../utils/httpRequest";
// import { useSocket } from "../../../components/common/SocketIo";
// import _ from "lodash";
// import { useSelector } from "react-redux";
// import { rootReducersState } from "../../../reducers";
// import React, { useState, useRef } from "react";
// import httpRequest from "../../../utils/httpRequest";

// const UploadVideoWithCover = () => {
//   const coverInputRef = useRef(null);
//   const videoInputRef = useRef(null);

//   const [coverImage, setCoverImage] = useState(null);
//   const [videoFile, setVideoFile] = useState(null);
//   const [isSaving, setIsSaving] = useState(false);
//   const [progress, setProgress] = useState(0);
//   const [message, setMessage] = useState('');
//   const socket = useSocket();
//   const sessionReducer = useSelector(
//     ({ session }: rootReducersState) => session
//   );
//   const userId = _.get(sessionReducer, "currentUser.id", 0);

//   // Handle cover image selection
//   const handleCoverChange = (e) => {
//     const file = e.target.files[0];
//     if (!file) return;
//     if (!file.type.startsWith("image/")) {
//       alert("Please select a valid image file for cover.");
//       return;
//     }
//     setCoverImage(file);
//   };

//   // Handle video file selection
//   const handleVideoChange = (e) => {
//     const file = e.target.files[0];
//     if (!file) return;
//     // Validate file type for mp4 or mov
//     if (!file.type.includes("mp4") && !file.type.includes("mov")) {
//       alert("Please select a valid video file (mp4 or mov).");
//       return;
//     }
//     setVideoFile(file);
//   };

//   // Save video and cover image to backend
//   const handleSave = async () => {
//     if (!coverImage || !videoFile) {
//       alert("Please select both a cover image and a video file.");
//       return;
//     }

//     const formData = new FormData();
//     // Append the cover image and video file using the keys expected by your backend
//     formData.append("cover_image", coverImage, coverImage.name);
//     formData.append("files", videoFile, videoFile.name);
//     // Append any additional fields
//     formData.append("isWechat", false);
//     formData.append("title", "My Video");
//     formData.append("description", "Uploaded via React app");

//     try {
//       setIsSaving(true);
//       await httpRequest().post(        `/video-studio/app/upload/profile`,        formData     );
//       alert("Upload successful!");
//       // Reset state and file inputs
//       setCoverImage(null);
//       setVideoFile(null);
//       if (coverInputRef.current) coverInputRef.current.value = "";
//       if (videoInputRef.current) videoInputRef.current.value = "";
//     } catch (error) {
//       console.error("Error uploading files:", error);
//       alert("Error uploading files");
//     } finally {
//       setIsSaving(false);
//     }
//   };
//   useEffect(() => {
//      // Log when the socket connects
//     socket.on("connect", () => {
//       console.log("✅ Connected to Socket.IO server");
//     });
  
//      // Join the video room
//     const videoRoom = `${userId}_video_room`;
//     socket.emit("createVideoRoom", videoRoom);
  
//     // Listen for progress updates
//     socket.on("profileVideoUploadProgress", (data) => {
//       console.log("🔥 Received uploadProgress Event:", data);
//       // if (data.userId === userId) {
//         setProgress(data.progress);
//         if (data.progress === 100) {
//           setProgress(100);
//           setIsSaving(false);
//           setMessage("Upload successful!");
//         }
//       // }
//     });
  
//     return () => {
//       console.log("🛑 Removing WebSocket listeners...");
//       // socket.off("profileVideoUploadProgress");
//     };
//   }, [socket, userId]);

// //   useEffect(() => {
// //     if (!socket) {
// //         console.log("❌ WebSocket instance is null");
        
// //         return;

// //     }
 
// // if(socket){
// //   socket.emit("createVideoRoom", `${userId}_video_room`);

// // }
// //     socket.on("profileVideoUploadProgress", (data) => {
// //         console.log("🔥 Received uploadProgress Event:", data);
// //         if (data.userId === userId) {
// //             setProgress(data.progress);
// //             if(data.progress===100){
// //               setProgress(100);
// //               setIsSaving(false);
// //               setMessage("Upload successful!");
// //             }
// //         }
// //     });

// //     return () => {
// //         console.log("🛑 Removing WebSocket listeners...");
// //         // socket.off("uploadProgress");
// //         // socket.off("uploadComplete");
// //         // socket.off("uploadError");
// //     };
// // }, [socket,userId]);


//   return (
//     <div style={{ padding: "20px" }}>
//       <h2>Upload Video with Cover Image</h2>
//       <div style={{ marginBottom: "10px" }}>
//         <label>
//           Cover Image:
//           <input
//             type="file"
//             accept="image/*"
//             ref={coverInputRef}
//             onChange={handleCoverChange}
//           />
//         </label>
//       </div>
//       <div style={{ marginBottom: "10px" }}>
//         <label>
//           Video File:
//           <input
//             type="file"
//             accept="video/mp4,video/mov"
//             ref={videoInputRef}
//             onChange={handleVideoChange}
//           />
//         </label>
//       </div>
//       <button onClick={handleSave} disabled={isSaving}>
//         {isSaving ? "Saving..." : "Save Video"}
//       </button>
//            {/* ✅ Progress Bar */}
//   {progress > 0 && progress < 100 && (
//     <>
//         <div style={{ marginTop: "10px", width: "100%", height: "10px", backgroundColor: "#ccc" }}>
//         <div
//           style={{
//             width: `${progress}%`,
//             height: "100%",
//             backgroundColor: progress === 100 ? "green" : "blue",
//             transition: "width 0.3s ease-in-out",
//           }}
//         ></div>
//       </div>
//       {message && <p style={{ marginTop: "10px", color: progress === 100 ? "green" : "blue" }}>{message}</p>}
//   </>
//     )}
//     </div>
//   );
// };

// export default UploadVideoWithCover;




import React, { useState, useRef, useEffect } from "react";
import httpRequest from "../../../utils/httpRequest";
import { useSelector } from "react-redux";
import { rootReducersState } from "../../../reducers";
import _ from "lodash";
import { useSocket } from "../../../components/common/SocketIo";

const UploadVideoWithCover = () => {
  const coverInputRef = useRef(null);
  const videoInputRef = useRef(null);
  const [coverImage, setCoverImage] = useState(null);
  const [videoFile, setVideoFile] = useState(null);
  // const [progress, setProgress] = useState(0);
  // const [message, setMessage] = useState('');
  const [isSaving, setIsSaving] = useState(false);
  // actualProgress is the value received from backend
  const [actualProgress, setActualProgress] = useState(0);
  // displayProgress is what the user sees (incremented one by one)
  const [displayProgress, setDisplayProgress] = useState(0);
  const [message, setMessage] = useState("");
  const socket = useSocket();
  const sessionReducer = useSelector(
    ({ session }: rootReducersState) => session
  );
  const userId = _.get(sessionReducer, "currentUser.id", 0);

  // Handle cover image selection
  const handleCoverChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (!file.type.startsWith("image/")) {
      alert("Please select a valid image file for cover.");
      return;
    }
    setCoverImage(file);
  };

  const handleVideoChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (!file.type.includes("mp4") && !file.type.includes("mov")) {
      alert("Please select a valid video file (mp4 or mov).");
      return;
    }
    setVideoFile(file);
  };

  const handleSave = async () => {
    if (!coverImage || !videoFile) {
      alert("Please select both a cover image and a video file.");
      return;
    }

    const formData = new FormData();
    formData.append("cover_image", coverImage, coverImage.name);
    formData.append("files", videoFile, videoFile.name);
    formData.append("isWechat", false);
    formData.append("title", "My Video");
    formData.append("description", "Uploaded via React app");

    try {
      setIsSaving(true);
      await httpRequest().post(`/video-studio/app/upload/profile`, formData);
      alert("Upload successful!");
      setCoverImage(null);
      setVideoFile(null);
      if (coverInputRef.current) coverInputRef.current.value = "";
      if (videoInputRef.current) videoInputRef.current.value = "";
    } catch (error) {
      console.error("Error uploading files:", error);
      alert("Error uploading files");
      setIsSaving(false);
    }
  };

  // Listen for socket events and update actual progress
  useEffect(() => {
    socket.on("connect", () => {
      console.log("✅ Connected to Socket.IO server");
    });

    const videoRoom = `${userId}_video_room`;
    socket.emit("createVideoRoom", videoRoom);

    socket.on("profileVideoUploadProgress", (data) => {
      console.log("🔥 Received uploadProgress Event:", data);
      // Update the actual progress from the backend
      setActualProgress(data.progress);
      if (data.progress === 100) {
        setMessage("Upload successful!");
        setIsSaving(false);
      }
    });

    return () => {
      console.log("🛑 Removing WebSocket listeners...");
      socket.off("profileVideoUploadProgress");
    };
  }, [socket, userId]);

  // Effect to smoothly increment the displayProgress until it reaches actualProgress.
  useEffect(() => {
    if (displayProgress < actualProgress) {
      const timer = setInterval(() => {
        setDisplayProgress((prev) => {
          if (prev < actualProgress) {
            return prev + 1;
          }
          clearInterval(timer);
          return prev;
        });
      }, 30); // Adjust the delay (in ms) to control the speed of incrementation
      return () => clearInterval(timer);
    }
  }, [actualProgress, displayProgress]);

  return (
    <div style={{ padding: "20px" }}>
      <h2>Upload Video with Cover Image</h2>
      <div style={{ marginBottom: "10px" }}>
        <label>
          Cover Image:
          <input type="file" accept="image/*" ref={coverInputRef} onChange={handleCoverChange} />
        </label>
      </div>
      <div style={{ marginBottom: "10px" }}>
        <label>
          Video File:
          <input type="file" accept="video/mp4,video/mov" ref={videoInputRef} onChange={handleVideoChange} />
        </label>
      </div>
      <button onClick={handleSave} disabled={isSaving}>
        {isSaving ? "Uploading..." : "Upload Video"}
      </button>
      {/* Progress Display */}
      {(displayProgress > 0 || actualProgress > 0) && (
        <div style={{ marginTop: "20px" }}>
          {/* Numeric display of progress */}
          <h3>Progress: {displayProgress}%</h3>
          <div
            style={{
              marginTop: "10px",
              width: "100%",
              height: "10px",
              backgroundColor: "#ccc",
            }}
          >
            <div
              style={{
                width: `${displayProgress}%`,
                height: "100%",
                backgroundColor: displayProgress === 100 ? "green" : "blue",
                transition: "width 0.3s ease-in-out",
              }}
            ></div>
          </div>
          {message && (
            <p
              style={{
                marginTop: "10px",
                color: displayProgress === 100 ? "green" : "blue",
              }}
            >
              {message}
            </p>
          )}
        </div>
      )}
    </div>

    
  );
};

export default UploadVideoWithCover;



// import React, { useState, useRef, useEffect } from "react";
// import httpRequest from "../../../utils/httpRequest";
// import { useSocket } from "../../../components/common/SocketIo";
// import _ from "lodash";
// import { useSelector } from "react-redux";
// import { rootReducersState } from "../../../reducers";

// const UploadVideoWithCover = () => {
//   const coverInputRef = useRef(null);
//   const videoInputRef = useRef(null);
  
//   const [coverImage, setCoverImage] = useState(null);
//   const [videoFile, setVideoFile] = useState(null);
//   const [isSaving, setIsSaving] = useState(false);
//   const [progress, setProgress] = useState(0);
//   const [message, setMessage] = useState('');
//   const [progressQueue, setProgressQueue] = useState([]);
//   const [processing, setProcessing] = useState(false);
  
//   const socket = useSocket();
//   const sessionReducer = useSelector(({ session }: rootReducersState) => session);
//   const userId = _.get(sessionReducer, "currentUser.id", 0);

//   // Handle cover image selection
//   const handleCoverChange = (e) => {
//     const file = e.target.files[0];
//     if (!file) return;
//     if (!file.type.startsWith("image/")) {
//       alert("Please select a valid image file for cover.");
//       return;
//     }
//     setCoverImage(file);
//   };

//   // Handle video file selection
//   const handleVideoChange = (e) => {
//     const file = e.target.files[0];
//     if (!file) return;
//     if (!file.type.includes("mp4") && !file.type.includes("mov")) {
//       alert("Please select a valid video file (mp4 or mov).");
//       return;
//     }
//     setVideoFile(file);
//   };

//   // Save video and cover image to backend
//   const handleSave = async () => {
//     if (!coverImage || !videoFile) {
//       alert("Please select both a cover image and a video file.");
//       return;
//     }

//     const formData = new FormData();
//     formData.append("cover_image", coverImage, coverImage.name);
//     formData.append("files", videoFile, videoFile.name);
//     formData.append("isWechat", false);
//     formData.append("title", "My Video");
//     formData.append("description", "Uploaded via React app");

//     try {
//       setIsSaving(true);
//       await httpRequest().post(`/video-studio/app/upload/profile`, formData);
//       alert("Upload successful!");
//       setCoverImage(null);
//       setVideoFile(null);
//       if (coverInputRef.current) coverInputRef.current.value = "";
//       if (videoInputRef.current) videoInputRef.current.value = "";
//     } catch (error) {
//       console.error("Error uploading files:", error);
//       alert("Error uploading files");
//     } finally {
//       setIsSaving(false);
//     }
//   };

//   // Process progress queue one by one with delay
//   useEffect(() => {
//     if (!processing && progressQueue.length > 0) {
//       setProcessing(true);
//       const nextProgress = progressQueue[0];

//       setTimeout(() => {
//         setProgress(nextProgress);
//         setProgressQueue((prevQueue) => prevQueue.slice(1)); // Remove processed item
//         setProcessing(false);
//       }); 
//     }
//   }, [progressQueue, processing]);

//   useEffect(() => {
//     socket.on("connect", () => {
//       console.log("✅ Connected to Socket.IO server");
//     });

//     const videoRoom = `${userId}_video_room`;
//     socket.emit("createVideoRoom", videoRoom);

//     socket.on("profileVideoUploadProgress", (data) => {
//       console.log(`🔥 Received uploadProgress Event:`, data);

//       setProgressQueue((prevQueue) => [...prevQueue, data.progress]);

//       if (data.progress === 100) {
//         setIsSaving(false);
//         setMessage("Upload successful!");
//       }
//     });

//     return () => {
//       console.log("🛑 Removing WebSocket listeners...");
//       socket.off("profileVideoUploadProgress");
//     };
//   }, [socket, userId]);

//   return (
//     <div style={{ padding: "20px" }}>
//       <h2>Upload Video with Cover Image</h2>
//       <div style={{ marginBottom: "10px" }}>
//         <label>
//           Cover Image:
//           <input type="file" accept="image/*" ref={coverInputRef} onChange={handleCoverChange} />
//         </label>
//       </div>
//       <div style={{ marginBottom: "10px" }}>
//         <label>
//           Video File:
//           <input type="file" accept="video/mp4,video/mov" ref={videoInputRef} onChange={handleVideoChange} />
//         </label>
//       </div>
//       <button onClick={handleSave} disabled={isSaving}>
//         {isSaving ? "Saving..." : "Save Video"}
//       </button>

//       {/* ✅ Progress Bar */}
//       {progress > 0 && (
//         <>
//           <div style={{ marginTop: "10px", width: "100%", height: "10px", backgroundColor: "#ccc" }}>
           
//             <div
//               style={{
//                 width: `${progress}%`,
//                 height: "100%",
//                 backgroundColor: progress === 100 ? "green" : "blue",
//                 transition: "width 0.3s ease-in-out",
//               }}
//             ></div>
//                   <span style={{ position: "absolute", left: "50%", transform: "translateX(-50%)", fontWeight: "bold" }}>
//                   {Math.floor(progress)}%
//           </span>
//           </div>
//           {message && <p style={{ marginTop: "10px", color: progress === 100 ? "green" : "blue" }}>{message}</p>}
//         </>
//       )}
//     </div>
//   );
// };

// export default UploadVideoWithCover;
